import AsyncStorage from '@react-native-async-storage/async-storage'
import * as Sentry from '@sentry/react-native'

export const FEATURES_KEY = 'FeatureToggles'

export interface Features {
  showEditorLogs: boolean
  ownerBumps: boolean
  notifications: boolean
  notificationsSound: boolean
  uiAudioEnabled: boolean
  developerMode: boolean
  theme: 'light' | 'dark'
}

export const DEFAULT_FEATURES: Features = {
  showEditorLogs: false,
  ownerBumps: false,
  notifications: false,
  notificationsSound: false,
  uiAudioEnabled: true,
  developerMode: false,
  theme: 'light',
}

export const featureLoader: Promise<Features> = AsyncStorage.getItem(
  FEATURES_KEY
).then((str) => {
  console.log('FeatureProvider:loading stored features')
  let features: Features
  if (str) {
    console.log('FeatureProvider:found stored features', str)
    try {
      features = { ...DEFAULT_FEATURES, ...JSON.parse(str) }
    } catch (e) {
      features = DEFAULT_FEATURES
      Sentry.captureException(e)
    }
  } else {
    console.log('FeatureProvider:no stored features')
    features = DEFAULT_FEATURES
  }
  return features
})
